import React from 'react';
import { Link } from 'react-router-dom';
import { ResponsiveContainer } from 'recharts';

/**
 * Titled card wrapping a responsive recharts chart. Pass a chart element as children.
 * With `historyTo`, the title and a "View history" link open that history page.
 */
const ChartCard: React.FC<{ title: string; empty?: boolean; historyTo?: string; children: React.ReactElement }> = ({
  title,
  empty,
  historyTo,
  children,
}) => (
  <section className="surface">
    {historyTo ? (
      <div className="d-flex justify-content-between align-items-baseline gap-2 flex-wrap mb-3">
        <h2 className="mb-0">
          <Link to={historyTo} className="history-title-link">
            {title}
          </Link>
        </h2>
        <Link to={historyTo} className="small history-view-link">
          View history <span aria-hidden="true">›</span>
        </Link>
      </div>
    ) : (
      <h2>{title}</h2>
    )}
    {empty ? (
      <p className="muted mb-0">No data for this range.</p>
    ) : (
      <div className="chart-box">
        <ResponsiveContainer width="100%" height="100%">
          {children}
        </ResponsiveContainer>
      </div>
    )}
  </section>
);

export default ChartCard;
